import { DEFAULT_GETTERS } from '@/modules/b2b/constants';

export default {
  ...DEFAULT_GETTERS,
  list: (state) => state.list,
  exploreRelatedCategory: (state) => state.exploreRelatedCategory
};
